import { useNavigate } from "react-router-dom"

import Style from "./style"
import back from "./asset/back.svg"

const PageTitle = ({ children }) => {
    const navigate = useNavigate()

    return (
        <Style.Wrapper>
            <button onClick={() => navigate(-1)}>
                <img src={back} />
            </button>
            <h2>{children}</h2>
            <p />
        </Style.Wrapper>
    )
}

export default PageTitle